exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2866c2c2!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductStationaryAvailability/StationaryAvailability.vue
// module id = 856
// module chunks = 2